/* global GOOGLE_API_KEY:true */
import React from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Divider, Steps, Typography } from "antd";
import GoogleMapReact from "google-map-react";
import { formatDistance } from "@/utils/utils";
// import CopyTrackingLink from "@/components/CopyTrackingLink";
import AddressMarker from "./AddressMarker";

const { Step } = Steps;
const { Title } = Typography;

export const LocationDetails = ({
  // shipmentId,
  dropOffAddress,
  pickupAddress,
  distance,
}) => {
  if (!pickupAddress || !dropOffAddress) return null;

  const onMapRender = ({ map, maps }) => {
    const bounds = new maps.LatLngBounds();

    bounds.extend(new maps.LatLng(pickupAddress.latitude, pickupAddress.longitude));
    bounds.extend(new maps.LatLng(dropOffAddress.latitude, dropOffAddress.longitude));

    // Directions API
    const directionsService = new maps.DirectionsService();
    const directionsRenderer = new maps.DirectionsRenderer({
      suppressMarkers: true, // Hide default A/B markers
    });

    directionsRenderer.setMap(map);
    directionsService.route(
      {
        origin: {
          lat: pickupAddress.latitude,
          lng: pickupAddress.longitude,
        },
        destination: {
          lat: dropOffAddress.latitude,
          lng: dropOffAddress.longitude,
        },
        travelMode: maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === "OK") {
          directionsRenderer.setDirections(response);
        } else {
          // only catch the error because we still have the markers on the map
          console.error("Directions request failed due to", status);
        }
        // center the map
        map.fitBounds(bounds);
      },
    );
  };

  return (
    <>
      <Title level={4}>Shipment Distance: {formatDistance(distance)} Miles</Title>
      <Steps
        style={{
          marginBottom: 32,
        }}
      >
        <Step
          status="finish"
          title={pickupAddress?.name ?? "Pickup"}
          description={`${pickupAddress.simplifyAddress}, ${pickupAddress.zipCode}` ?? "N/A"}
          icon={<EnvironmentOutlined style={{ color: "#4888F4" }} />}
        />
        <Step
          status="finish"
          title={dropOffAddress?.name ?? "Drop off"}
          description={`${dropOffAddress.simplifyAddress}, ${dropOffAddress.zipCode}` ?? "N/A"}
          icon={<EnvironmentOutlined style={{ color: "#DD4B3E" }} />}
        />
      </Steps>
      <div style={{ height: 400 }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: GOOGLE_API_KEY }}
          defaultCenter={{
            lat: 0,
            lng: 0,
          }}
          defaultZoom={10}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={onMapRender}
        >
          <AddressMarker
            lat={pickupAddress?.latitude}
            lng={pickupAddress?.longitude}
            label={`${pickupAddress.simplifyAddress}, ${pickupAddress.zipCode}`}
            color="#4888F4"
          />
          <AddressMarker
            lat={dropOffAddress?.latitude}
            lng={dropOffAddress?.longitude}
            label={`${dropOffAddress.simplifyAddress}, ${dropOffAddress.zipCode}`}
            color="#DD4B3E"
          />
        </GoogleMapReact>
      </div>
      {/* <CopyTrackingLink shipmentId={shipmentId} /> */}
      <Divider
        style={{
          marginBottom: 32,
        }}
      />
    </>
  );
};

export default LocationDetails;
